import { useState } from "react";
import { Button, IconProvider } from "../ui";

interface SubscribeStep5Props {
  onNext: (engineState: string[]) => void;
}

const SubscribeStep5: React.FC<SubscribeStep5Props> = ({ onNext }) => {
  const [engineState, setEngineState] = useState<string[]>([]);
 
  const engineOptions = [
    { label: "Unreal Engine", value: "unreal-engine" },
    { label: "Unity", value: "unity" },
    { label: "Godot", value: "godot" },
    { label: "Lumberyard  ", value: "lumberyard" },
    { label: "CryEngine", value: "cryengine" },
    { label: "GameMaker", value: "gamemaker" },
    { label: "Roblox", value: "roblox" },
    { label: "Fortnite", value: "fortnite" },
    { label: "Meta Horizon", value: "meta-horizon" },
    { label: "Custom Engine", value: "custom-engine" },
    { label: "Web-GL", value: "web-gl" },
    { label: "Other", value: "other" },
  ];


  const handleEngineOptionToggle = (value: string) => {
    setEngineState((prev) =>
      prev.includes(value)
        ? prev.filter((option) => option !== value)
        : [...prev, value]
    );
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onNext(engineState);
  };

  return (
    <>
 <h2 className="text-xl font-bold text-left text-gray-900 ">
        Which game engine(s) are you using?
      </h2>
      <p className="text-sm text-gray-900 pb-2">
        (You can select multiple options if you have multiple projects)
      </p>
      
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {engineOptions.map((option) => (
            <Button
              key={option.value}
              variant="toggleCheck"
              isChecked={engineState.includes(option.value)}
              onToggle={() => handleEngineOptionToggle(option.value)}
              className="h-12 text-sm"
            >
              {option.label}
            </Button>
          ))}
        </div>  

        <div className="flex justify-center mt-4">
          <Button
            variant="default"
            onClick={handleSubmit}
            className="w-full"
            disabled={engineState.length === 0}
          >
            Continue
          </Button>
        </div>
    </>
  );
};
export default SubscribeStep5;
